import React from 'react';
import PropTypes from 'prop-types';
import { RadioDropdown } from '@saucelabs/sl-component-form';

const DesktopBrowserConfiguratorOS = ({ onChange, os, oses }) => {
  const options = oses.map((item) => ({
    text: item,
    value: item,
  }));

  return (
    <RadioDropdown
      input={{
        onChange,
        value: os,
      }}
      isInputForm
      label="OS Version"
      options={options}
    />
  );
};

DesktopBrowserConfiguratorOS.defaultProps = {
  os: null,
};

DesktopBrowserConfiguratorOS.propTypes = {
  onChange: PropTypes.func.isRequired,
  os: PropTypes.node,
  oses: PropTypes.array.isRequired,
};

export default DesktopBrowserConfiguratorOS;
